<template>
  <div class="container">
    <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
         <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="active">
            <a href="#pedidos-list" aria-controls="pedidos" role="tab" data-toggle="tab">PEDIDOS VIGENTES</a>
          </li>
          <li role="presentation">
            <a href="#historial" aria-controls="historial" role="tab" data-toggle="tab">HISTORIAL DE PEDIDOS</a>
          </li>
          <router-link to="/hacerpedido" class="btn btn-primary btn-fill pull-right">NUEVO PEDIDO</router-link>
          </ul>
          <div class="tab-content">
          <div role="tabpanel" class="tab-pane fade in active no-padding" id="pedidos-list">
          <ul class="order-list">
            <li class="order-list-item" v-for="pedido in pedidosEnCurso" :key="pedido._id"  :class="{'pedido-cancelado': pedido.estado.toLowerCase() === 'cancelado'}">
              <table>
                <tbody>
                  <tr>
                    <td class="table-calendar">
                      <div class="calendar-style" :class="{current: pedido.esDeHoy}">
                        <span class="dayweek">{{pedido.fechaEntrega | diaSemana}}</span>
                        <span class="date">{{pedido.fechaEntrega | diaNumero}}</span>
                      </div>
                    </td>
                    <td class="table-order">
                      <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3" v-for="plato in pedido.platos" :key="plato._id">
                          <div class="order">
                            <div class="order-categ" style="word-break: break-all;">{{plato.plato.categoria.nombre | toUpper}}</div>
                            <div class="order-name" style="word-break: break-all;">{{plato.cantidad}}x {{plato.plato.nombre}}</div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="table-result">
                      <div class="table-cell">
                        <div class="order">
                          <div class="order-categ">
                            <label class="label-status" :class="{ cancelado: pedido.estado.toLowerCase() === 'cancelado', oncourse: pedido.estado.toLowerCase() !== 'cancelado' }">{{pedido.estado}}</label>
                            <span>{{pedido.numero}}</span>
                          </div>
                          <a href="#" @click.prevent="setComanda(pedido)"  data-target="#detalle-pedido" class="order-link">Ver detalles</a>
                          <div class="order-price semibold">TOTAL: {{pedido.montoTotal | formatMoneda}}</div>
                          <button title="Cancelar" v-if="pedido.cancelable && !pedido.esDeHoy && pedido.estado === 'Recibido'" class="btn btn-sm btn-outline btn-quit add-to-cart" @click="clickCancelar(pedido._id)">CANCELAR</button>
                          <span v-if="!pedido.cancelable" class="text-danger">Ya no puede ser cancelado</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--
              <button type="button" class="btn btn-xs btn-default btn-delete" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="Eliminar pedido"><i class="fa fa-times"></i></button>
              -->
            </li>
          </ul>

          </div>
          <div role="tabpanel" class="tab-pane fade" id="historial">
            <div class="table-header form smart-form">
              <div class="row">
                <div class="col-xs-6 col-sm-4 col-md-3 col-lg-4">
                  <div class="form-group">
                    <label>Desde</label>
                    <date-picker v-model="fechaDesde" :max-date="new Date()"></date-picker>
                  </div>
                </div>
                <div class="col-xs-6 col-sm-4 col-md-3 col-lg-4">
                  <div class="form-group">
                    <label>Hasta</label>
                    <date-picker v-model="fechaHasta" :max-date="new Date()"></date-picker>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-6 col-lg-4 pull-right">
                  <div class="form-group">
                    <label>Búsqueda rápida</label>
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="Buscar..." v-model="busquedaRapida">
                      <span class="input-group-btn">
                      <button class="btn btn-default" type="button"><i class="fa fa-search"></i></button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-container">
              <table class="table table-hover table-stripped table-no-first-pad" ref="tablahistorica" style="width:100%">
                <thead>
                  <tr>
                    <th>Numero</th>
                    <th>Fecha</th>
                    <th>Detalle</th>
                    <th>Total</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="entrega in historicoFiltradoPaginado">
                    <td>{{entrega.numero}}</td>
                    <td>{{entrega.fechaEntrega | fechaTabla}}</td>
                    <td>{{entrega.detalle}}</td>
                    <td>{{entrega.montoTotal | formatMoneda}}</td>
                    <td>
                      <ul class="table-actions smart-form">
                        <li>
                          <a href="#" @click.prevent="setComanda(entrega)"  data-target="#detalle-pedido" class="btn btn-xs btn-ghost">
                            <i class="fa fa-actions fa-eye"></i>
                          </a>
                        </li>
                      </ul>
                    </td>
                  </tr>                
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-4">
                
              </div>
              <div class="col-xs-12 col-sm-4">
                <nav aria-label="Page navigation">
                  <ul class="pagination pagination-sm">
                    <li :class="{disabled: paginador.currentPage === 1}">
                      <a href="#" @click.prevent="goToPrevPage()" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li v-for="i in paginador.currentPages" :class="{active: paginador.currentPage === i}"><a href="#" @click.prevent="goToPage(i)">{{i}}</a></li>
                    <li :class="{disabled: paginador.currentPage === paginador.currentPages}">
                      <a href="#" @click.prevent="goToNextPage()" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="col-xs-12 col-sm-4 text-right">
                <template v-if="paginador.currentItems > 0">
                  <span class="size-11">Mostrando registros del {{desde}} al {{hasta}} de un total de {{paginador.currentItems}} registros <template v-if="paginador.totalItems > paginador.currentItems">(filtrado de un total de {{paginador.totalItems}} registros)</template></span>
                </template>
                
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="modal fade detalle-pedido" id="detalle-pedido" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document" v-if="entregaComanda">
      <div class="modal-content">
        <div class="modal-body" >
        
        <h2>Pedido #{{entregaComanda.numero}}</h2>
        <p class="size-16">
          Fecha y hora: <span class="semibold">{{entregaComanda.fechaEntrega | fechaTabla}}</span><br/>
        </p>
        <template v-for="item, idx in entregaComanda.platosAgrupados">
          <h3>{{idx}}</h3>
          <ul class="order-list">
            <li v-for="plato in item" :key="plato._id">
              <span>{{plato.cantidad}}x {{plato.plato.nombre}}</span>
            </li>
          </ul>
        </template>
        </div>
      </div>
      </div>
    </div><!-- Fin modal comanda-->
  </div>
</template>
<script>
  import $ from 'jquery'
  import '../../assets/js/jquery-ui.min.js'
  import '../../assets/css/jquery-ui.min.css'
  import 'datatables.net'
  import 'datatables.net-dt/css/jquery.dataTables.css'
  import DatePicker from '../Shared/DatePicker'
  // import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css'
  // import 'bootstrap-datepicker'
  // import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min.js'
  import _ from 'lodash'
  import moment from 'moment'
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'
  moment.updateLocale('es')

  export default {
    components: {
      'date-picker': DatePicker
    },
    computed: {
      desde () {
        const me = this
        let resultado = ((me.paginador.currentPage - 1) * me.paginador.pageSize) + 1
        return resultado
      },
      hasta () {
        const me = this
        return me.desde + me.historicoFiltradoPaginado.length - 1
      },
      pedidosEnCurso () {
        const me = this
        let pedidos = me.pedidos.filter((pedido) => {
          return new Date(pedido.fechaEntrega) >= me.corte
        })
        pedidos.forEach((pedido) => {
          pedido.esDeHoy = moment(new Date(pedido.fechaEntrega)).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
        })
        return pedidos
      },
      pedidosHistorico () {
        const me = this
        let pedidos = me.pedidos.filter((pedido) => {
          return new Date(pedido.fechaEntrega) < me.corte
        })
        pedidos.forEach((pedido) => {
          let detalle = pedido.platos.map((plato) => {
            return `${plato.cantidad}x ${plato.plato.nombre}`
          })
          pedido.detalle = detalle.join(' + ')
        })
        me.paginador.totalItems = pedidos.length
        me.paginador.totalPages = Math.ceil(me.paginador.totalItems / me.paginador.pageSize)
        return pedidos
      },
      historicoFiltrado () {
        const me = this
        let pedidos = me.pedidosHistorico
        if (me.fechaDesde) {
          pedidos = pedidos.filter((pedido) => {
            return new Date(pedido.fechaEntrega) > new Date(me.fechaDesde)
          })
        }
        if (me.fechaHasta) {
          pedidos = pedidos.filter((pedido) => {
            return new Date(pedido.fechaEntrega) < moment(new Date(me.fechaHasta)).endOf('day').toDate()
          })
        }
        if (me.busquedaRapida.trim() !== '') {
          pedidos = pedidos.filter((pedido) => {
            return pedido.detalle.trim().toLowerCase().includes(me.busquedaRapida.trim().toLowerCase())
          })
        }
        me.paginador.currentItems = pedidos.length || 0
        me.paginador.currentPages = Math.ceil(pedidos.length / me.paginador.pageSize)
        me.paginador.currentPage = 1
        return pedidos
      },
      historicoFiltradoPaginado () {
        const me = this
        let pedidos = me.historicoFiltrado
        let desde = (me.paginador.currentPage - 1) * me.paginador.pageSize
        let hasta = desde + me.paginador.pageSize
        let filtrados = pedidos.filter((pedido, idx) => {
          return idx >= desde && idx < hasta
        })
        return filtrados
      }
    },
    data () {
      return {
        categorias: [],
        corte: moment().startOf('day').toDate(),
        busquedaRapida: '',
        entregaComanda: null,
        fechaDesde: null,
        fechaHasta: undefined,
        historico: [],
        paginador: {
          pageSize: 10,
          currentPage: 1,
          currentPages: 1,
          totalPages: 0,
          itemDesde: 0,
          itemHasta: 0,
          totalItems: 0,
          currentItems: 0
        },
        pedidos: [],
        pendientes: [],
        tabla: undefined
      }
    },
    filters: {
      diaSemana: (value) => {
        return moment(new Date(value)).utc().format('ddd').toUpperCase()
      },
      diaNumero: (value) => {
        return moment(new Date(value)).utc().format('DD')
      },
      fechaTabla: (value) => {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      },
      formatMoneda: (value) => {
        return '$' + parseFloat(value).toFixed(2)
      },
      toUpper (value) {
        return value.toUpperCase()
      },
      toStr (value) {
        return JSON.stringify(value)
      }
    },
    methods: {
      clickCancelar (id) {
        const me = this
        swal({
          title: 'Confirmar cancelación',
          text: '¿Realmente desea cancelar el pedido?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, cancelar',
          cancelButtonText: 'No, quiero el pedido'
        }).then(() => {
          me.$http.post('/api/users/cancelarpedido', {
            id: id
          }).then(({body}) => {
            me.$emit('mostrar-notificacion', 'El pedido se ha cancelado correctamente', 'success')
            let buscarPedido = me.pedidos.find((pedido) => {
              return pedido._id === id
            })
            if (buscarPedido) {
              buscarPedido.estado = 'Cancelado'
            }
          }, (err) => {
            console.error(err)
            me.$emit('mostrar-notificacion', err.body.error, 'error')
          })
        }, (dismiss) => {
          console.log('El ususario no quiere cancelar')
        })
      },
      goToNextPage () {
        const me = this
        if (me.paginador.currentPage < me.paginador.totalPages) {
          me.paginador.currentPage += 1
        }
      },
      goToPage (i) {
        const me = this
        if (i > 0 && i <= me.paginador.totalPages) {
          me.paginador.currentPage = i
        }
      },
      goToPrevPage () {
        const me = this
        if (me.paginador.currentPage > 1) {
          me.paginador.currentPage -= 1
        }
      },
      setComanda (entrega) {
        this.entregaComanda = entrega
        this.entregaComanda.platosAgrupados = _.groupBy(entrega.platos, (plato) => {
          return plato.plato.categoria.nombre
        })
        $('#detalle-pedido.modal').modal()
      }
    },
    mounted () {
      const me = this
      me.$emit('cerrar-modal')
      this.$http.get('/api/users/mispedidos', {
        params: {
          time: +new Date()
        }
      }).then((res) => {
        me.pedidos = res.body.pedidos
        me.categorias = res.body.categorias
      }, (error) => {
        console.log(error)
      })
    },
    created () {
    }
  }
</script>
<style scoped>
  .order-name {
    white-space: -moz-pre-wrap; /* Mozilla */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap;  /* CSS 2.1 */
    white-space: pre-line; /* CSS 3 */
    word-wrap: break-word; /* IE */
  }
  .paginate_button:hover {
    color: #333!important;
    border: 1px solid #979797;
    background-color: #fff;
    background: linear-gradient(180deg,#fff,#93a512);
}
.label-status.cancelado {
  background-color: red; 
}
.pedido-cancelado {
  background-color: #ffeeee;
}
</style>



// WEBPACK FOOTER //
// MisPedidos.vue?0c8a0514